import React from 'react'

const TrafficManagementHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
            <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                    <div className='min-w-0 max-w-full'>
                        <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                            Traffic Data Management System
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                ArcGIS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                PostgreSQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                              We partnered with a Middle Eastern Ministry of Road Transportation to architect a mission-critical Traffic
                              Data Management System (TDMS) that successfully enabled smooth traffic flow during FIFA World Cup 2022. Built
                              with Spring Boot, Angular, and PostgreSQL with ArcGIS API integration, the platform processes traffic data from
                              500,000+ vehicles daily, reduced data breach risks by 40%, and delivered GIS-based visualizations crucial to
                              the Ministry's Master Plan. Deployed on AWS Cloud with Docker containerization, the solution provided accurate,
                              real-time traffic insights that transformed infrastructure planning and established new standards for
                              government-scale traffic management systems.
                            </p>

                    </div>
                    <div className='min-w-0 max-w-full'>
                      <img src='/case_studies/title-banner/traffic-app-title-banner.png' alt='Traffic Data Management System' className='w-full h-auto max-w-full'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrafficManagementHero
